import React from 'react';
import { Header, Title } from '@trussworks/react-uswds';

export function USWDSHeader(props) {
  return <Header {...props} />;
}

export function USWDSHeaderTitle(props) {
  return <Title {...props} />;
}
